import React from "react";
import { Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { tesaBlue } from "../../styles/colors";

function CustomLoading(): JSX.Element {
  return (
    <Box padding={10}>
      <Box
        style={{
          position: "absolute",
          left: "50%",
          transform: "translate(-50%)",
        }}
      >
        <CircularProgress style={{ color: tesaBlue }} />
      </Box>
    </Box>
  );
}

export default CustomLoading;
